export const GET_CHALLENGE_PROGRESS = 'GET_CHALLENGE_PROGRESS';